import { Box, Form, Text, Title } from '@factorialco/deprecated-design-system'
import { EditTrainingTrainingFragment } from 'generated/resources/graphql'

import SelectField from 'modules/core/components/SelectField'
import Selector from 'modules/core/components/Selector'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { RelatorioUnicoFormValues } from 'modules/trainings/components/Revamp/TrainingEditMode/types'
import { useEditTrainingContext } from 'modules/trainings/hooks/EditTraining/useEditTrainingContext'
import { useCreateTrainingRelatorioUnicoField } from 'modules/trainings/hooks/TrainingRelatorioUnicoFields/useCreateTrainingRelatorioUnicoField'
import { useUpdateTrainingRelatorioUnicoField } from 'modules/trainings/hooks/TrainingRelatorioUnicoFields/useUpdateTrainingRelatorioUnicoField'

export const Relatorio = ({
  training,
  saved,
  trainingRelatorioUnicoField,
}: {
  training: EditTrainingTrainingFragment
  saved: boolean
  trainingRelatorioUnicoField: EditTrainingTrainingFragment['relatorioUnicoField']
}) => {
  const { setIsDirty, setSaved } = useEditTrainingContext()

  const { create } = useCreateTrainingRelatorioUnicoField()
  const { loading, update } = useUpdateTrainingRelatorioUnicoField()

  const areaEducationOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.accounting_and_taxation'), value: '344' },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.agriculture_forestry_fisheries_not_classified'
      ),
      value: '629',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.arts_programs_not_classified'),
      value: '219',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.audio_visuals_and_media_production'),
      value: '213',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.basic_educator_teacher_training'),
      value: '144',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.basic_programs'), value: '010' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.beauty_care'), value: '815' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.biology_and_biochemistry'), value: '421' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.business_sciences_programs_not_classified'),
      value: '349',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.chemical_process_technology'),
      value: '524',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.chemistry'), value: '442' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.civil_construction_engineering'),
      value: '582',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.commerce'), value: '341' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.computer_science'), value: '481' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.computer_science_from_users_perspective'),
      value: '482',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.computer_science_programs_not_classified'),
      value: '489',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.construction_and_motor_vehicle_repair'),
      value: '525',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.crafts'), value: '215' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.dental_sciences'), value: '724' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.design'), value: '214' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.diagnostic_therapeutic_technologies'),
      value: '725',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.education_sciences'), value: '142' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.economics'), value: '314' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.electricity_and_energy'), value: '522' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.electronics_and_automation'), value: '523' },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.engineering_and_related_techniques_programs_not_classified'
      ),
      value: '529',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.environmental_protection_not_classified'),
      value: '859',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.environmental_protection_technology'),
      value: '851',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.environmental_sciences'), value: '422' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.fine_arts'), value: '211' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.finance_banking_and_insurance'),
      value: '343',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.fishing'), value: '624' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.floriculture_and_gardening'),
      value: '622',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.food_industries'), value: '541' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.foreign_languages_and_literatures'),
      value: '222',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.forestry_and_hunting'), value: '623' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.history_and_archaeology'), value: '225' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.hospitality_and_catering'), value: '811' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.humanities_programs_not_classified'),
      value: '229',
    },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.information_and_journalism_programs_not_classified'
      ),
      value: '329',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.journalism_and_reporting'), value: '321' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.law'), value: '380' },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.library_science_archiving_and_documentation_bad'
      ),
      value: '322',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.life_sciences_programs_not_classified'),
      value: '429',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.literacy'), value: '080' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.management_and_administration'),
      value: '345',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.manufacturing_industries_not_classified'),
      value: '549',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.marketing_and_advertising'), value: '342' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.materials_industries'),
      value: '543',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.mathematics'), value: '461' },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.mathematics_and_statistics_programs_not_classified'
      ),
      value: '469',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.medicine'), value: '721' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.metallurgy_and_metalworking'),
      value: '521',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.military_security'), value: '863' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.native_language_and_literature'),
      value: '223',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.nursing'), value: '723' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.occupational_health_and_safety'),
      value: '862',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.organizational_company_framework'),
      value: '347',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.performing_arts'), value: '212' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.personal_development'), value: '090' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.personal_services_not_classified'),
      value: '819',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.pharmacy'), value: '727' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.philosophy_and_ethics'), value: '226' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.physical_sciences_programs_not_classified'),
      value: '449',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.physics'), value: '441' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.political_science_and_citizenship'),
      value: '313',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.preschool_educator_training'),
      value: '143',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.protection_of_people_and_property'),
      value: '861',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.psychology'), value: '311' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.public_health_services'), value: '853' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.religion_and_theology'), value: '221' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.secretarial_and_administrative_work'),
      value: '346',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.security_services_not_classified'),
      value: '869',
    },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.social_and_behavioral_sciences_programs_not_classified'
      ),
      value: '319',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.social_services_not_classified'),
      value: '769',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.social_work_and_guidance'),
      value: '762',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.sociology_and_other_studies'),
      value: '312',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.specific_subject_area_teacher_training'),
      value: '145',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.sports'), value: '813' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.statistics'), value: '462' },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.teacher_training_education_sciences_programs_not_classified'
      ),
      value: '149',
    },
    {
      label: i18n.t(
        'trainings.annex_c_relatorio_unico.technological_area_teachers_trainers_training'
      ),
      value: '146',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.textile_clothing_footwear_leather'),
      value: '542',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.therapy_and_rehabilitation'), value: '726' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.tourism_and_leisure'), value: '812' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.transport_services'), value: '840' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.urban_architecture'), value: '581' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.veterinary_sciences'), value: '640' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.unknown_or_unspecified'), value: '999' },
  ]

  const modalidadeOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.professional_courses'), value: '01' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.learning_courses'), value: '02' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.youth_training_courses'), value: '03' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.adult_training_courses'), value: '04' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.tech_specialization'), value: '05' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.modular_training_ncq'), value: '06' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.training_action'), value: '07' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.continuous_training_ncq'), value: '08' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.unknown'), value: '99' },
  ]

  const iniciativaOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.employer_responsibility'), value: '01' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.worker_initiative_training'), value: '02' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.user_company_initiative'), value: '03' },
  ]

  const entidadeOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.own_company'), value: '01' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.employment_center_training'), value: '02' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.participative_mgmt_training'), value: '03' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.employers_business_assoc'), value: '04' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.trade_union_assoc'), value: '05' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.schools_universities'), value: '06' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.training_companies'), value: '07' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.private_companies_training'), value: '08' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.other_entities'), value: '09' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.unknown'), value: '99' },
  ]

  const certificadoOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.qualification_diploma'), value: '01' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.qualification_certificate'), value: '02' },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.vocational_training_certificate'),
      value: '03',
    },
    {
      label: i18n.t('trainings.annex_c_relatorio_unico.vocational_training_non_certified'),
      value: '04',
    },
    { label: i18n.t('trainings.annex_c_relatorio_unico.no_certificate_failure'), value: '05' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.attendance_certificate'), value: '06' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.higher_education_diploma'), value: '07' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.not_applicable'), value: '08' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.unknown'), value: '99' },
  ]

  const nivelOptions = [
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_1'), value: '01' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_2'), value: '02' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_3'), value: '03' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_4'), value: '04' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_5'), value: '05' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_6'), value: '06' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_7'), value: '07' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.level_8'), value: '08' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.no_level_assigned'), value: '09' },
    { label: i18n.t('trainings.annex_c_relatorio_unico.unknown'), value: '99' },
  ]

  const areaEducationSelectorOptions = areaEducationOptions.map(({ label, value }, i) => {
    return (
      <Selector.Option key={i} value={value} label={label} searchValue={label}>
        {label}
      </Selector.Option>
    )
  })

  const form = useForm<RelatorioUnicoFormValues>({
    defaultValues: {
      certificateType: trainingRelatorioUnicoField?.certificateType || '',
      educationArea: trainingRelatorioUnicoField?.educationArea || '',
      qualificationLevel: trainingRelatorioUnicoField?.qualificationLevel || '',
      trainingEntity: trainingRelatorioUnicoField?.trainingEntity || '',
      trainingInitiative: trainingRelatorioUnicoField?.trainingInitiative || '',
      trainingModality: trainingRelatorioUnicoField?.trainingModality || '',
    },
    onSubmit: async (data) => {
      if (trainingRelatorioUnicoField) {
        const result = await update({
          ...data,
          id: trainingRelatorioUnicoField.id,
        })

        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.training_relatorio_fields.fields_updated_error'),
          })
        })

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('trainings.training_relatorio_fields.fields_updated'),
          })

          const values = form.values
          form.resetForm({ values })
        }

        return handled
      } else {
        const result = await create({ ...data, trainingId: String(training.id) })

        const handled = handleResult(result, () => {
          app.setFlash({
            type: 'wrong',
            message: i18n.t('trainings.training_relatorio_fields.fields_created_error'),
          })
        })

        if (handled.success) {
          app.setFlash({
            type: 'correct',
            message: i18n.t('trainings.training_relatorio_fields.fields_created'),
          })

          const values = form.values
          form.resetForm({ values })
        }

        return handled
      }
    },
  })

  useEffect(() => {
    if (saved && (!form.isSubmitting || !loading)) {
      form.handleSubmit()
      setSaved(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saved, form.isSubmitting, loading])

  useEffect(() => {
    setIsDirty(form.dirty)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.dirty])

  const handleOnChange = (value: unknown) => {
    if (typeof value === 'string') {
      form.setValues({ ...form.values, educationArea: value })
    }
  }

  return (
    <Box padding="s24" gap="s24">
      <Title
        title="Relatorio Único"
        description={i18n.t('trainings.training_relatorio_fields.description')}
      ></Title>
      <Form onSubmit={() => form.handleSubmit()} padding={null}>
        <Box gap="s6">
          <Text.Normal size="200" weight="medium" color="grey1000">
            {i18n.t('trainings.training_relatorio_fields.area_of_education')}
          </Text.Normal>
          <Selector.Popover
            placeholder={i18n.t('trainings.training_relatorio_fields.option_placeholder_minus')}
            headerLabel={i18n.t('trainings.training_relatorio_fields.area_of_education')}
            searchPlaceholder={i18n.t('trainings.training_relatorio_fields.search')}
            isMultiSelect={false}
            blankLabel={i18n.t('common.choose')}
            value={[form.values.educationArea]}
            onChange={handleOnChange}
          >
            {areaEducationSelectorOptions}
          </Selector.Popover>
        </Box>
        <SelectField
          options={modalidadeOptions}
          label={i18n.t('trainings.training_relatorio_fields.training_modality')}
          none={i18n.t('trainings.training_relatorio_fields.option_placeholder')}
          value={form.values.trainingModality}
          onChange={(value) => form.setValues({ ...form.values, trainingModality: value })}
        />
        <SelectField
          options={iniciativaOptions}
          label={i18n.t('trainings.training_relatorio_fields.training_initiative')}
          none={i18n.t('trainings.training_relatorio_fields.option_placeholder')}
          value={form.values.trainingInitiative}
          onChange={(value) => form.setValues({ ...form.values, trainingInitiative: value })}
        />
        <SelectField
          options={entidadeOptions}
          label={i18n.t('trainings.training_relatorio_fields.training_entity')}
          none={i18n.t('trainings.training_relatorio_fields.option_placeholder')}
          value={form.values.trainingEntity}
          onChange={(value) => form.setValues({ ...form.values, trainingEntity: value })}
        />
        <SelectField
          options={certificadoOptions}
          label={i18n.t('trainings.training_relatorio_fields.type_certificate_diploma')}
          none={i18n.t('trainings.training_relatorio_fields.option_placeholder')}
          value={form.values.certificateType}
          onChange={(value) => form.setValues({ ...form.values, certificateType: value })}
        />
        <SelectField
          options={nivelOptions}
          none={i18n.t('trainings.training_relatorio_fields.option_placeholder')}
          label={i18n.t('trainings.training_relatorio_fields.qualification_level_of_training')}
          value={form.values.qualificationLevel}
          onChange={(value) => form.setValues({ ...form.values, qualificationLevel: value })}
        />
      </Form>
    </Box>
  )
}
